export var SET_AXIOS_READY = "SET_AXIOS_READY";
export var SET_AXIOS_ERROR = "SET_AXIOS_ERROR";
export var SET_TOKEN = "SET_TOKEN";
export var LOAD_CONFIGURATION = "LOAD_CONFIGURATION";
export var setAxiosReady = function () { return ({
    type: SET_AXIOS_READY
}); };
export var setAxiosError = function (payload) { return ({
    type: SET_AXIOS_ERROR,
    payload: payload
}); };
export var setToken = function (payload) { return ({
    type: SET_TOKEN,
    payload: payload
}); };
export var loadConfiguration = function (payload) { return ({
    type: LOAD_CONFIGURATION,
    payload: payload
}); };
